import { useQuery } from "@tanstack/react-query";
import { usersApi } from "@/app/lib/api/users";
import { SupabaseUser, CompanyUser, Company } from "@/app/lib/supabase/types";
import { userQueryKeys } from "./useUserInformation";

export function useUserCompanies(userInfo: SupabaseUser | null | undefined) {
  return useQuery<{ companyUsers: CompanyUser[], companies: Company[] }, Error, { companyUsers: CompanyUser[], companies: Company[] }>({
    queryKey: userQueryKeys.companies(userInfo?.id || ""),
    queryFn: () => {
      if (!userInfo) throw new Error("No user information available");
      return usersApi.getUserCompanies(userInfo.id);
    },
    enabled: !!userInfo,
    staleTime: 5 * 60 * 1000, // Companies might change more frequently, cache for 5 minutes
    gcTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
  });
}